import React from 'react';
import useDonutChart from './hooks/useDonutChart';
import ChartContainer from '../Services/charts/apex-charts/ChartContainer';

export const Donut = ({ 
    chartData = [],
    subtitles,
    colors,
    title,
    height,
    className = '',
    isMoney = false,
    series = null,
    percentage = false,
    labelsOutside = false
 }) => {
    const { chartConfig } = useDonutChart({
        chartData,
        subtitles,
        colors,
        isMoney,
        series,
        percentage,
        labelsOutside
    });


    return (
        <ChartContainer
            title={title}
            options={chartConfig.options}
            series={chartConfig.series}
            height={height ?? (labelsOutside ? 420 : 300)}
            type="donut"
            className={className}
        />
    );
};
